// Permisos que la dueña puede dar a cada persona de su equipo (sql/088).
// La dueña siempre tiene todo. La BD hace cumplir: gastos, borrar y servicios;
// el resto se controla en la app.
export const PERMISOS = [
  { grupo: 'Ventas', items: [
    { clave: 'ventas_todas', nombre: 'Ver las ventas de todo el negocio', ayuda: 'Si está apagado, solo ve las ventas que ella misma hizo.' },
  ] },
  { grupo: 'Dinero', items: [
    { clave: 'corte', nombre: 'Hacer el corte del día', ayuda: 'Cuadrar la caja al cerrar el día.' },
    { clave: 'balance', nombre: 'Ver el Balance', ayuda: 'Ventas, ingresos y gastos del período. Muestra ganancias.' },
    { clave: 'cuentas', nombre: 'Ver cuentas y saldos', ayuda: 'Cuánto dinero hay en efectivo, banco y tarjetas.' },
    { clave: 'gastos', nombre: 'Registrar y ver gastos' },
    { clave: 'por_cobrar', nombre: 'Cobrar fiado (Por cobrar)' },
    { clave: 'cierre', nombre: 'Hacer el cierre de mes', ayuda: 'Muestra la utilidad del mes.' },
  ] },
  { grupo: 'Productos y servicios', items: [
    { clave: 'productos', nombre: 'Crear y editar productos', ayuda: 'Incluye reponer stock y la lista de stock bajo.' },
    { clave: 'costos', nombre: 'Ver costos y ganancias', ayuda: 'Precio de costo, ganancia por producto y en el Inicio.' },
    { clave: 'servicios', nombre: 'Administrar servicios', ayuda: 'Crear, editar y desactivar servicios.' },
    { clave: 'ia', nombre: 'Usar fotos con IA', ayuda: 'Gasta los créditos de IA de tu plan.' },
  ] },
  { grupo: 'Análisis y control', items: [
    { clave: 'reportes', nombre: 'Ver reportes', ayuda: 'Incluye ganancias y márgenes.' },
    { clave: 'borrar', nombre: 'Borrar registros', ayuda: 'Clientes, cotizaciones, citas, órdenes, pedidos y productos.' },
  ] },
];

// ¿Esta persona puede hacer `clave`? La dueña (y admin) siempre sí.
export function tienePermiso(negocio, clave) {
  if (!negocio) return false;
  if (negocio.rol === 'duena' || negocio.rol === 'admin') return true;
  return !!(negocio.permisos && negocio.permisos[clave]);
}
